import { useTranslation } from "react-i18next";
import ".";

export const Translate = (value: string, params = { count: 0 }) => {
	const translation = useTranslation();
	return translation.t(value, params);
};
